// Who sees Cost of work (/work/cost and /work/cost/detail) and the chip that
// leads there. Same substring rule as auth/financeAccess.js, same caveat: this
// decides what is SHOWN; the analytics API's cost endpoints are superuser-only
// and carry no per-person rule, so hiding here is convenience, not security.
// Named by Patrick on 2026-09-22: himself, Walker, Riley, Eric and Luke.
export const COST_USER_SUBSTRINGS = ['patrick', 'walker', 'riley', 'eric', 'luke'];

export const isCostUser = (profile) => {
    if (!profile) return false;
    const haystack = `${profile.name ?? ''} ${profile.email ?? ''} ${profile.preferred_username ?? ''}`.toLowerCase();
    return COST_USER_SUBSTRINGS.some((s) => haystack.includes(s));
};
